import * as yup from 'yup';
import { tokenBaseValidation } from 'utils/validation';

type InputTokenAmount = {
  label?: string;
  max: string;
  decimals: number;
  required: boolean;
};

export function createDepositValidation({
  tokenAmount,
}: {
  tokenAmount: InputTokenAmount;
}) {
  const tokenValidation = tokenBaseValidation
    .label(tokenAmount.label ?? '')
    .bnMoreThan(
      '0',
      tokenAmount.decimals,
      'Should not be zero or less than zero'
    )
    .bnMax(tokenAmount.max, tokenAmount.decimals, 'Insufficient balance');

  return yup.object({
    tokenAmount: tokenAmount.required
      ? tokenValidation.required()
      : tokenValidation.notRequired(),
    slippage: yup.number().required('Slippage is required'),
  });
}

type InputAmount = {
  label?: string;
  max: number;
  required: boolean;
};

export function createWithdrawValidation({
  tokenAmount,
}: {
  tokenAmount: InputAmount;
}) {
  const tokenValidation = yup
    .number()
    .typeError('Token amount must be a number')
    .positive('Token amount must be greater than 0')
    .label(tokenAmount.label ?? '')
    .max(tokenAmount.max, 'Insufficient balance');

  return yup.object({
    tokenAmount: tokenAmount.required
      ? tokenValidation.required()
      : tokenValidation.notRequired(),
    slippage: yup.number().required('Slippage is required'),
  });
}
